import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { INTERBRANCH_MODAL_UPDATE } from '../../actions/type';
import { getFileTypeIcon } from '../../Helpers/FileFunction';
// import { setDeleteFileRedux, setFileToViewRedux, setModalRedux, setViewFileModalRedux, } from '../../Redux/Slice/ModalSlice';

function FilesList({ files, onTargetClick, name }) {

    // const { reduxFiles } = useSelector((state) => state.modalRedux)



    const dispatch = useDispatch()

    let handleOpen = (file) => {


        dispatch({
            type: INTERBRANCH_MODAL_UPDATE,
            payload: {
                modalName: "ViewFileModal",
                isVisible: true,
                data: {
                    file: URL.createObjectURL(file),
                    type: file.type
                }
            }
        })


    }


    let handleDelete = (file) => {

        console.log("File:",file)

        dispatch({
            type: INTERBRANCH_MODAL_UPDATE,
            payload: {
                modalName: "removeFileModal",
                isVisible: true,
                data: {
                    name: file.name
                }
            }
        })


    }



    console.log(files);



    return (
        <div className='file-list-container'>

            <div className="file-list-body">


                {
                    files && files.length > 0 ? files.map((element, key) => {


                        return (

                            <div key={key} className="fil-list-item">
                                <div className="left">

                                    <div className="file-icon">
                                        <img src={getFileTypeIcon(element)} alt="" />
                                    </div>

                                    <div className="file-tittle">
                                        {element?.file?.name}
                                    </div>

                                </div>

                                <div className="right">

                                    <div className="file-view" onClick={() => { handleOpen(element?.file) }}>

                                        <img src={require('../../assets/InterBranch/PNGIcons/view11.png')} alt="" />

                                    </div>

                                    <div className="devider">&nbsp;</div>

                                    <div className="file-delete" onClick={() => { handleDelete(element) }}>

                                        <img src={require('../../assets/InterBranch/PNGIcons/delete.png')} alt="" />

                                    </div>

                                </div>
                            </div>


                        )
                    }) : null
                }



            </div>

            <div className="file-list-footer" onClick={onTargetClick}>
                <span className='first-child'>Click here or Drag files to upload</span>
                <span>(Supported Format - PDF, PNG, JPEG, JPG, DOC, DOCX, DCM, ZIP. </span>
                <span>Maximum size per file is 5MB</span>
                <span>Maximum number of files is 3)</span>
            </div>


        </div>
    )
}

export default FilesList
